import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';

import {ExamFilter} from '@app/api/models/exam';
import {ExamType} from '../../../../api/models/exam-type';

import {ExamTypeService} from '@app/api/services/exam-type.service';
import {MessageService} from '@app/api/services/message.service';

import {ExamListComponent} from '../exam-list.component';
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {WaButtonDirective, WaCheckboxDirective, WaDialogDirective, WaInputDirective} from "angular-awesome";

@Component({
    selector: 'app-exam-filter',
    templateUrl: './exam-filter.component.html',
    styleUrls: ['./exam-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, WaDialogDirective, WaButtonDirective, WaInputDirective, WaCheckboxDirective]
})
export class ExamFilterComponent implements OnInit {

  examTypes: ExamType[] = [];

  filterForm = new UntypedFormGroup({
    moduleCode: new UntypedFormControl(null),
    moduleName: new UntypedFormControl(null),
    begin: new UntypedFormControl(null),
    end: new UntypedFormControl(null),
    examTypeId: new UntypedFormControl(null),
    participantsFrom: new UntypedFormControl(null),
    participantsTo: new UntypedFormControl(null),
    isRepetition: new UntypedFormControl(null)
  });

  constructor(private dialogRef: DialogRef<ExamFilter,ExamListComponent>,
              private examTypeService: ExamTypeService,
              private msgService: MessageService,
              @Inject(DIALOG_DATA) data: { filter: ExamFilter }) {

    if (!data || !data.filter)
      return;

    const filter = data.filter;
    this.filterForm.controls['moduleCode'].setValue(filter.moduleCode);
    this.filterForm.controls['moduleName'].setValue(filter.moduleName);
    this.filterForm.controls['begin'].setValue(filter.begin);
    this.filterForm.controls['end'].setValue(filter.end);
    this.filterForm.controls['examTypeId'].setValue(filter.examTypeId);
    this.filterForm.controls['participantsFrom'].setValue(filter.participantsFrom);
    this.filterForm.controls['participantsTo'].setValue(filter.participantsTo);
    this.filterForm.controls['isRepetition'].setValue(filter.isRepetition);
  }

  private getExamTypes(): void {
    this.examTypeService.getAll().subscribe({
      next: examTypes => this.examTypes = examTypes,
      error: err => {
        this.msgService.log(err.message);
        this.msgService.showSimple('Could not fetch exam types.');
      }
    });
  }

  ngOnInit(): void {
    this.getExamTypes();
  }

  apply(): void {
    const filter: ExamFilter = {
      moduleCode: this.moduleCode || null,
      moduleName: this.moduleName || null,
      begin: this.begin || null,
      end: this.end || null,
      examTypeId: this.examTypeId,
      participantsFrom: this.participantsFrom || null,
      participantsTo: this.participantsTo || null,
      isRepetition: this.isRepetition || null
    };

    this.dialogRef.close(filter);
  }

  reset(): void {
    this.filterForm.reset();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  get moduleCode() { return this.filterForm.value.moduleCode }
  get moduleName() { return this.filterForm.value.moduleName }
  get begin() { return this.filterForm.value.begin }
  get end() { return this.filterForm.value.end }
  get examTypeId() { return this.filterForm.value.examTypeId }
  get participantsFrom() { return this.filterForm.value.participantsFrom }
  get participantsTo() { return this.filterForm.value.participantsTo }
  get isRepetition() { return this.filterForm.value.isRepetition }
}
